import * as stylex from "@stylexjs/stylex";
import { colors, fontSizes, fonts } from "@softmax/design-system/tokens.stylex";

export function PlaySubpageHeader({
  leagueName,
  playHref,
  title,
}: {
  readonly leagueName: string;
  readonly playHref: string;
  readonly title: string;
}) {
  return (
    <header {...stylex.props(styles.header)}>
      <a href={playHref} {...stylex.props(styles.back)}>
        ‹ Play
      </a>
      <p {...stylex.props(styles.eyebrow)}>{leagueName} · Play</p>
      <h1 {...stylex.props(styles.title)}>{title}</h1>
    </header>
  );
}

const styles = stylex.create({
  header: { display: "flex", flexDirection: "column", gap: 6 },
  back: {
    width: "fit-content",
    fontSize: fontSizes.caption,
    fontWeight: 500,
    color: colors.muted,
    textDecoration: { default: "none", ":hover": "underline" },
    textUnderlineOffset: 3,
    ":focus-visible": {
      outlineWidth: 2,
      outlineStyle: "solid",
      outlineColor: colors.foreground,
      outlineOffset: 2,
    },
  },
  eyebrow: {
    margin: 0,
    fontSize: fontSizes.caption,
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    color: colors.muted,
  },
  title: {
    margin: 0,
    fontFamily: fonts.mono,
    fontSize: {
      default: fontSizes.pageTitle,
      "@media (min-width: 1024px)": fontSizes.pageTitleWide,
    },
    fontWeight: 600,
    lineHeight: { default: "34px", "@media (min-width: 1024px)": "38px" },
    letterSpacing: "-0.3px",
    color: colors.foreground,
  },
});
